import Text             from 'components/Text';
import { TextProps }    from 'components/Text';
import Value            from 'components/Value';
import { observer }     from 'mobx-react';
import AbstractApiModel from 'modelx/models/abstracts/AbstractApiModel';
import React            from 'react';

type Mode = 'createdBy' | 'updatedBy';

export default observer((props: { mode?: Mode, model: AbstractApiModel } & TextProps) => {
	const { mode, model } = props;

	let at = model['createdAt'];
	let by = model['createdBy'];

	switch (mode) {
		case 'updatedBy':
			at = model['updatedAt'];
			by = model['updatedBy'];
			break;
	}

	let text = `Le ${at.format('L [à] LT')}`;

	if (by.isLoaded) {
		text += ` par ${by.fullName}`;
	}

	return <Text {...props}><Value loading={by.isLoading} value={text} /></Text>;
});